// src/utils/excelUtils.js

import * as XLSX from 'xlsx';

/**
 * Hàm tạo và tải xuống file Excel mẫu.
 * @param {Array<Object>} sampleData - Mảng chứa một đối tượng mẫu với dữ liệu.
 * @param {string} fileName - Tên file Excel sẽ được tải xuống.
 */
export const downloadExcelTemplate = (sampleData, fileName) => {
  // Tạo một worksheet từ dữ liệu mẫu
  const worksheet = XLSX.utils.json_to_sheet(sampleData);

  // Tạo một workbook mới
  const workbook = XLSX.utils.book_new();

  // Thêm worksheet vào workbook
  XLSX.utils.book_append_sheet(workbook, worksheet, "Data");

  // Tự động điều chỉnh độ rộng các cột cho đẹp hơn
  const colWidths = Object.keys(sampleData[0]).map(key => ({ wch: Math.max(key.length, String(sampleData[0][key]).length) + 5 }));
  worksheet["!cols"] = colWidths;

  // Xuất file và kích hoạt tải xuống
  XLSX.writeFile(workbook, `${fileName}.xlsx`);
};